<template>
  <div class="">
    <div class="checkbox-item" v-for="coupon in coupons" :key="coupon.id">
      <label class="label" :for="`coupon-${coupon.id}`">
        {{ coupon.name }}
        <input
          type="checkbox"
          :id="`coupon-${coupon.id}`"
          :checked="isCouponSelected(coupon.id)"
          @change="couponToggled(coupon.id)"
        />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions("search", ["couponToggled"])
  },

  computed: {
    ...mapGetters("search", ["coupons", "isCouponSelected"])
  }
}
</script>

<style src="./CouponRefine.scss" lang="scss"></style>
